import { Position } from 'geojson';
import { Point } from 'components/common/types/Geometry';

type LatLong = { latitude: number; longitude: number };
type GeometryPoint = LatLong | Point | Position;

const convertToPoint = (coordinates: GeometryPoint): Point => {
  if ('x' in coordinates) {
    return coordinates;
  }

  if ('longitude' in coordinates) {
    return { x: coordinates.longitude, y: coordinates.latitude };
  }

  return { x: coordinates[0], y: coordinates[1] };
};

export const isPointInsidePolygon = (point: GeometryPoint, polygon: GeometryPoint[]): boolean => {
  const { x, y } = convertToPoint(point);
  let isInside = false;

  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const { x: xi, y: yi } = convertToPoint(polygon[i]);
    const { x: xj, y: yj } = convertToPoint(polygon[j]);

    const intersect = yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;

    if (intersect) isInside = !isInside;
  }

  return isInside;
};
